<template>
  <div>
    <a-layout :has-sider="true" style="min-height: 100vh">
      <sidebar />

      <a-layout>
        <navbar />

        <a-layout-content class="responsive-margin">
          <router-view v-slot="{ Component, route }">
            <transition
              :name="route.meta.transition === false ? '' : 'fade'"
              mode="out-in"
            >
              <div :key="route.name">
                <component :is="Component"></component>
              </div>
            </transition>
          </router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import Sidebar from '../components/dashboard/sidebar.vue';
import Navbar from '../components/dashboard/navbar.vue';

export default {
  name: 'DashboardTemplate',
  components: {
    sidebar: Sidebar,
    navbar: Navbar
  },
  setup() {}
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.responsive-margin {
  margin: 48px 8px;
}

@media (min-width: 576px) {
  .responsive-margin {
    margin: 48px 16px;
  }
}
@media (min-width: 768px) {
  .responsive-margin {
    margin: 48px 24px;
  }
}
@media (min-width: 992px) {
  .responsive-margin {
    margin: 16px 48px;
  }
}
</style>
